/**
 * Renders the mini news hero on the home page, containing mini news item components
 * WARNING: Uses temporary dummy data
 */
import React from "react";
import MiniNewsItem from "./MiniNewsItem";
import { useState, useEffect } from "react";
import { processEpochMini } from "../utils/time";

const NewsHero = ({data}) => {

  return data ? (
    <div className="flex flex-col w-full px-2 xxs:px-4 sm:flex-row items-start justify-start sm:px-2 mt-2">
      
      <MiniNewsItem
        author={data[0].author_name}
        filename={data[0].img ? `https://buiha.org.uk/assets/img/resource/${data[0].img}` : "/placeholder2.jpg"}
        time={processEpochMini(data[0].date)}
        title={data[0].title}
        newsId={data[0].id}
        last={false}
        extra_classes={"sm:hidden"}
        url_override={data[0].url}
      />
      <MiniNewsItem
        author={data[1].author_name}
        filename={data[1].img ? `https://buiha.org.uk/assets/img/resource/${data[1].img}` : "/placeholder2.jpg"}
        time={processEpochMini(data[1].date)}
        title={data[1].title}
        newsId={data[1].id}
        last={false}
        extra_classes={""}
        url_override={data[1].url}
      />
      <MiniNewsItem
        author={data[2].author_name}
        filename={data[2].img ? `https://buiha.org.uk/assets/img/resource/${data[2].img}` : "/placeholder2.jpg"}
        time={processEpochMini(data[2].date)}
        title={data[2].title}
        newsId={data[2].id}
        last={false}
        extra_classes={"max-sm:hidden"}
        url_override={data[2].url}
      />
      <MiniNewsItem
        author={data[3].author_name}
        filename={data[3].img ? `https://buiha.org.uk/assets/img/resource/${data[3].img}` : "/placeholder2.jpg"}
        time={processEpochMini(data[3].date)}
        title={data[3].title}
        newsId={data[3].id}
        last={true}
        extra_classes={"hidden xl:flex"}
        url_override={data[3].url}
      />
    </div>
  ) : null;
};
export default NewsHero;
